// React Query обвивките за прехвърлянията, добавени с редизайна. Ключовете са
// под ["inventory", "transfers", …] — `invalidateAll` (useInventory.ts) и
// записът на прехвърляне ги изчистват заедно със заварения списък по склад.
// В локален режим (каса без интернет) складът е извън обхвата → заявките мълчат.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  annulTransfer,
  getTransfer,
  getTransfersReport,
  type TransfersReportParams,
} from "../api/inventoryTransfers";
import { useIsEdgeLocal } from "./useEdgeMode";
import { invalidateAll } from "./useInventory";

export const useTransfersReport = (params: TransfersReportParams | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "transfers", "report", params],
    queryFn: () => getTransfersReport(params!),
    enabled: !!params && !isLocal,
  });
};

// Едно прехвърляне; `null` → заявката не тръгва (записът вече е в router state)
export const useTransfer = (id: number | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "transfers", "one", id],
    queryFn: () => getTransfer(id as number),
    enabled: id != null && !isLocal,
    retry: false,
  });
};

export const useAnnulTransfer = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string | null }) =>
      annulTransfer(id, reason),
    onSuccess: () => invalidateAll(qc),
  });
};
